import { render, staticRenderFns } from "./DriverEditor.vue?vue&type=template&id=1ff0895a&scoped=true"
import script from "./DriverEditor.vue?vue&type=script&lang=js"
export * from "./DriverEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff0895a",
  null
  
)

export default component.exports